import {
  TrialDetailClinicalTrialType,
  TrialDetailProgress,
  TrialDetailResearchCategory,
} from '@/lib/gql/graphql'

// リサーチカテゴリーのマッピングオブジェクト
export const RESEARCH_CATEGORY_LABELS: Record<
  TrialDetailResearchCategory,
  string
> = {
  [TrialDetailResearchCategory.ClinicalResearchSpecified]: '特定臨床研究',
  [TrialDetailResearchCategory.ClinicalResearchNonSpecified]: '非特定臨床研究',
  [TrialDetailResearchCategory.ClinicalResearchOtherObservational]: '観察研究',
  [TrialDetailResearchCategory.ClinicalResearchOtherSurgicalProcedure]:
    '手術・手技',
  [TrialDetailResearchCategory.ClinicalResearchOtherOther]: 'その他',
  [TrialDetailResearchCategory.ClinicalResearchOtherPending]: '保留',
  [TrialDetailResearchCategory.ClinicalTrialSponsorInitiated]: '企業治験',
  [TrialDetailResearchCategory.ClinicalTrialInvestigatorInitiated]:
    '医師主導治験',
  [TrialDetailResearchCategory.ClinicalTrialPostMarketing]: '製造販売後試験',
  [TrialDetailResearchCategory.ClinicalTrialUsageResultsSurvey]: '使用成績調査',
  [TrialDetailResearchCategory.ClinicalTrialOther]: 'その他',
  [TrialDetailResearchCategory.ClinicalTrialPending]: '保留',
}

// 臨床試験タイプのマッピングオブジェクト
export const CLINICAL_TRIAL_TYPE_LABELS: Record<
  TrialDetailClinicalTrialType,
  string
> = {
  [TrialDetailClinicalTrialType.Main]: '主たる治験',
  [TrialDetailClinicalTrialType.Expanded]: '拡大治験',
  [TrialDetailClinicalTrialType.NeitherMainNorExpanded]:
    '主たる治験と拡大治験のいずれにも該当しない',
}

// 試験進捗状況のマッピングオブジェクト
export const TRIAL_PROGRESS_LABELS: Record<TrialDetailProgress, string> = {
  [TrialDetailProgress.BeforeOpen]: '募集前',
  [TrialDetailProgress.Opening]: '募集中',
  [TrialDetailProgress.Closed]: '募集終了',
  [TrialDetailProgress.Suspended]: '募集中断',
  [TrialDetailProgress.Completed]: '研究終了',
}
